import { AvailableOperationStatus } from "../operations/available-operation-status";
import { AvailableOperationTypes } from "../operations/available-operation-types";
import { OperationRequest } from "../operations/operation-request";
import { Routes } from "../routes";
import { Strategy } from "./abstract-strategy";

export class AutomaticDownloadStrat extends Strategy {

  public hasCondition(request: OperationRequest): boolean {

    const availableStatus = [
      AvailableOperationStatus.ACTIVA,
      AvailableOperationStatus.PENDIENTE_ENTREGA,
      AvailableOperationStatus.NO_ENTREGADO
    ];
    const hasActiveStatus = availableStatus.includes(request.state);
    if(request.operationType === AvailableOperationTypes.DWN && request.automaticDownload && ((request.authPreferenceResponse && request.acceptedAuth) || request.authPreferenceResponse === false) && hasActiveStatus){
      return true;
    }

    return false;
  }

  public setStrategy(request?: OperationRequest): void {
    this.pathToGo = Routes.FINISH_SIMPLE;
  }
}
